import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ServiceFeeData } from './types';

const initialState: ServiceFeeData = {
    account_id: "",
    account_name: "",
    service_fee_received_date: "",
    service_fee_type: "",
    from_date: "",
    to_date: "",
    target_amount: 0,
    target_achieved: 0,
    on_target_service_fee_percentage: 0,
    achievement_amount_received: 0,
    receipt_url: "",
    note: ""
};

// Define a type for keys of ServiceFeeData
type ServiceFeeKey = keyof ServiceFeeData;

// Define a payload type for our setField action
interface SetFieldPayload {
    key: ServiceFeeKey;
    value: string | number | File;
}

const serviceFeeSlice = createSlice({
    name: 'serviceFee',
    initialState,
    reducers: {
        // Set all fields at once
        setServiceFee: (state, action: PayloadAction<ServiceFeeData>) => {
            return action.payload;
        },
        // Update multiple fields at once
        updateServiceFee: (state, action: PayloadAction<Partial<ServiceFeeData>>) => {
            return { ...state, ...action.payload };
        },
        // Set a single field with key-value pair
        setField: (state, action: PayloadAction<SetFieldPayload>) => {
            const { key, value } = action.payload;
            // Type assertion needed because TypeScript can't infer 
            // that the value type matches the field type
            (state[key] as any) = value;
        },
        // Reset to initial state
        resetServiceFee: () => {
            return initialState;
        }
    }
});

export const {
    setServiceFee,
    updateServiceFee,
    setField,
    resetServiceFee
} = serviceFeeSlice.actions;

export default serviceFeeSlice.reducer;